import {
  createCampaignCommunicationObservable,
  createCampaignCommunicationEpic,
} from './createCampaignCommunication'
import {
  getCampaignTagsObservable,
  getCampaignTagsEpic,
} from './getCampaignTags'
import { getCampaignsObservable, getCampaignsEpic } from './getCampaigns'
import { getCampaignObservable, getCampaignEpic } from './getCampaign'
import { deleteCampaignObservable, deleteCampaignEpic } from './deleteCampaign'
import { resetCampaignObservable, resetCampaignEpic } from './resetCampaign'

export const observables = {
  createCampaignCommunicationObservable,
  getCampaignTagsObservable,
  getCampaignsObservable,
  getCampaignObservable,
  deleteCampaignObservable,
  resetCampaignObservable,
}

export default {
  createCampaignCommunicationEpic,
  getCampaignTagsEpic,
  getCampaignsEpic,
  getCampaignEpic,
  deleteCampaignEpic,
  resetCampaignEpic,
}
